module.exports = __webpack_public_path__ + "static/img-hero-desktop-34350587e0d46f5f8bf6d0b132bbe7e8.png";